import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from './util.service';
import { RateType } from '../enums/ratetype.enum';
import { type PerThermPipe } from '../pipes/per-therm.pipe';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  private perThermPipe: PerThermPipe | undefined;
  planData: any = {};

  constructor(private readonly utils: UtilService) {}

  setPerThermPipe(PerThermPipe: PerThermPipe): void {
    this.perThermPipe = PerThermPipe;
  }

  getBillRate(SaRateScheduleCode?: string, CustomerClass?: string, Rate?: any, Type?: string): string {
    const plan = this.getPlanData(SaRateScheduleCode, CustomerClass, Rate, Type);
    return plan.billRate;
  }

  getPlanType(SaRateScheduleCode: string, CustomerClass: string, Rate?: any, Type?: string): string {
    const plan = this.getPlanData(SaRateScheduleCode, CustomerClass, Rate, Type);
    return plan.planType;
  }

  getAllPlanData(
    SaRateScheduleCode?: string,
    CustomerClass?: string,
    Rate?: any,
    Type?: string,
    StatusFlag?: string,
  ): any {
    return this.getPlanData(SaRateScheduleCode, CustomerClass, Rate, Type, StatusFlag);
  }

  private getPlanData(
    SaRateScheduleCode?: string,
    CustomerClass?: string,
    Rate?: any,
    Type?: string,
    StatusFlag?: string,
  ): any {
    if (!this.utils.isNullOrUndefined(SaRateScheduleCode) && SaRateScheduleCode) {
      if (CustomerClass !== 'LRGCOM') {
        if (Type === RateType.Variable || Type === RateType.Undefined || Rate === RateType.Variable) {
          switch (true) {
            case SaRateScheduleCode.includes('NMX') || SaRateScheduleCode.includes('MEX'):
              this.planData.planType = 'NYMEX';
              this.planData.billRate = 'Market Based';
              break;
            case (SaRateScheduleCode.includes('IND') || SaRateScheduleCode.includes('IX')) &&
              !SaRateScheduleCode.includes('FIX'):
              this.planData.planType = 'Index';
              this.planData.billRate = 'Market Based';
              break;
            default:
              this.planData.planType = 'Variable Rate';
              this.planData.billRate = 'Varies';
              break;
          }
        } else {
          switch (true) {
            case SaRateScheduleCode.includes('FIX') || SaRateScheduleCode.includes('FX'):
              this.planData.planType = 'Fixed';
              this.planData.billRate = Rate ? this.perThermPipe?.transform(Rate.toString(), 'USD') + ' per therm' : '';
              break;
            case SaRateScheduleCode.includes('FLT'):
              this.planData.planType = 'OnePrice Plan';
              this.planData.billRate = Rate ? this.perThermPipe?.transform(Rate.toString(), 'USD') + ' per month' : '';
              break;
            case SaRateScheduleCode.includes('NMX') || SaRateScheduleCode.includes('MEX'):
              this.planData.planType = 'NYMEX';
              this.planData.billRate = 'Market Based';
              break;
            default:
              this.planData.planType = 'Complex';
              this.planData.billRate = 'Market Based';
              break;
          }
        }
      } else {
        if (Type === RateType.Variable || Type === RateType.Undefined || Rate === RateType.Variable) {
          switch (true) {
            case SaRateScheduleCode.includes('NMX') || SaRateScheduleCode.includes('MEX'):
              this.planData.planType = 'NYMEX';
              this.planData.billRate = 'Market Based';
              break;
            case SaRateScheduleCode.includes('IND') ||
              (SaRateScheduleCode.includes('IX') && !SaRateScheduleCode.includes('FIX')):
              this.planData.planType = 'Index';
              this.planData.billRate = 'Market Based';
              break;
            case SaRateScheduleCode.includes('VAR'):
              this.planData.planType = 'Variable Rate';
              this.planData.billRate = 'Varies';
              break;
            default:
              this.planData.planType = 'Complex';
              this.planData.billRate = 'Market Based';
              break;
          }
        } else {
          switch (true) {
            case SaRateScheduleCode.includes('FIX') || SaRateScheduleCode.includes('FX'):
              this.planData.planType = 'Fixed';
              this.planData.billRate = Rate ? this.perThermPipe?.transform(Rate.toString(), 'USD') + ' per therm' : '';
              break;
            case SaRateScheduleCode.includes('NMX') || SaRateScheduleCode.includes('MEX'):
              this.planData.planType = 'NYMEX';
              this.planData.billRate = 'Market Based';
              break;
            default:
              this.planData.planType = 'Complex';
              this.planData.billRate = 'Market Based';
              break;
          }
        }
      }
    } else if (StatusFlag === '10') {
      // Plan Details - Not Available for Pending Start Accounts
      this.planData.planType = 'Details coming soon';
    } else {
      this.planData.planType = '';
    }
    return this.planData;
  }
}
